import React, { useEffect, useState } from 'react';
import NCRFormLabel from '../Utilities/NCRFormLabel';
import { Modal } from '@mui/material';
import { Sheet } from '@mui/joy';

const MobileWarning = () => {
  const [isMobile, setIsMobile] = useState(false);

  const checkDevice = () => {
    const width = window.innerWidth;
    setIsMobile(width < 800);
  };

  useEffect(() => {
    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  if (!isMobile) return null;

  return (
    <Modal
      aria-labelledby="modal-title"
      aria-describedby="modal-desc"
      open={isMobile}
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <Sheet
        variant="outlined"
        sx={{ maxWidth: 500, borderRadius: 'md', boxShadow: 'lg' }}
      >
        <NCRFormLabel component="h2" sx={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#000000',
          p: 3,
        }}>
          This site is only compatible with desktop.
        </NCRFormLabel>
      </Sheet>
    </Modal>
  );
};

export default MobileWarning;
